import s from './style.module.scss';
import { useCallback, useState } from 'react';
import Question from './question';
import useStatusBarHeight from '@/hooks/useStatusBarHeight';

import { useTranslation } from 'react-i18next';

export default function Questionnaire() {
  const { t } = useTranslation();
  const statusBarHeight = useStatusBarHeight();
  const onBack = useCallback(() => {
    window?.nativeBridge && window.nativeBridge.callNativeFunction('goBack', null);
  }, []);
  const [showQuestion, setShowQuestion] = useState(false);

  return showQuestion ? (
    <Question />
  ) : (
    <div className={s.root}>
      <div onClick={onBack} className={s.navBar} style={{ top: `${statusBarHeight}rem` }}>
        <div className={s.backArrow} />
        {t('del account')}
      </div>

      <div className={s.title}>{t('DUET_QUESTIONNAIRE_ASKING_TITLE')}</div>
      <div className={s.subTitle}>{t('DUET_QUESTIONNAIRE_ASKING_SUBTITLE')}</div>
      <div className={s.confirmBitton} onClick={() => setShowQuestion(true)}>
        {t('DUET_QUESTIONNAIRE_ASKING_YES')}
      </div>
      <div className={s.bg} />
    </div>
  );
}
